import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import merge from 'lodash/merge'
import set from 'lodash/set'

export const getCamerasFromConfig = (base: any, diff: any): any => {
    return base?.vehicle_detection?.['camera-settings']?.cameras.map((camera: any, index: string | number) => {
        let cameraFinal = camera
        const diffCamera = diff?.vehicle_detection?.['camera-settings']?.cameras?.[index]
        if (diff?.vehicle_detection?.['camera-settings']?.cameras?.[index]) {
            cameraFinal = merge({}, camera, diffCamera)
        }
        return {
            ...cameraFinal,
            shutter_limits_min: cameraFinal.shutter_limits?.[0],
            shutter_limits_max: cameraFinal.shutter_limits?.[1],
            gain_limits_min: cameraFinal?.gain_limits?.[0],
            gain_limits_max: cameraFinal?.gain_limits?.[1],
            value: camera.id,
            label: camera.id
        }
    })
}

export const getSnoozeMinutesFromConfig = (base: any, diff: any): any => {
    let snoozeMinutes =
        base?.vehicle_detection?.['camera-settings']?.modules?.['brightness-history-safety-control']?.snooze_minutes

    if (diff?.vehicle_detection?.['camera-settings']?.modules?.['brightness-history-safety-control']?.snooze_minutes) {
        snoozeMinutes =
            diff.vehicle_detection?.['camera-settings']?.modules?.['brightness-history-safety-control']?.snooze_minutes
    }

    return snoozeMinutes
}

export const getResetHistoryValuesFromConfig = (base: any, diff: any): any => {
    let resetHistoryValues =
        base?.vehicle_detection?.['camera-settings']?.modules?.['brightness-history-value-update']?.reset_history_values

    if (
        diff?.vehicle_detection?.['camera-settings']?.modules?.['brightness-history-value-update']
            ?.reset_history_values !== undefined
    ) {
        resetHistoryValues =
            diff?.vehicle_detection['camera-settings']?.modules?.['brightness-history-value-update']
                ?.reset_history_values
    }

    return resetHistoryValues
}

export const getEnableRawImageControlFromConfig = (base: any, diff: any): any => {
    let enableRawImageControl =
        base?.vehicle_detection?.['camera-settings']?.modules?.['brightness-history-safety-control']
            ?.enable_raw_image_control

    if (
        diff?.vehicle_detection?.['camera-settings']?.modules?.['brightness-history-safety-control']
            ?.enable_raw_image_control !== undefined
    ) {
        enableRawImageControl =
            diff.vehicle_detection?.['camera-settings']?.modules?.['brightness-history-safety-control']
                ?.enable_raw_image_control
    }

    return enableRawImageControl
}

export const getInitialBrigtnessSetting = (camera: any): any => {
    let valuePlaceholder
    if (camera?.enable_brightness_control === true && camera?.enable_pid_control === true) {
        valuePlaceholder = 'enable_pid_control'
    }
    if (camera?.enable_brightness_control === true && camera?.enable_pid_control === false) {
        valuePlaceholder = 'historyControlOnly'
    }
    if (camera?.enable_brightness_control === false && camera?.enable_pid_control === false) {
        valuePlaceholder = 'dayAndNightSwitchBrightnessControlDisabled'
    }

    return valuePlaceholder
}

export const getPeriodicImagesEnableFromConfig = (base: any, diff: any): any => {
    const basePeriodicImagesEnable = base?.vehicle_detection?.['camera-settings']?.modules?.['periodic-images']?.enable
    const diffPeriodicImagesEnable = diff?.vehicle_detection?.['camera-settings']?.modules?.['periodic-images']?.enable

    // Overwrite base value if diff value exists
    const periodicImagesEnableFinal =
        diffPeriodicImagesEnable !== undefined ? diffPeriodicImagesEnable : basePeriodicImagesEnable

    return periodicImagesEnableFinal
}
export const getFramesQueueTriggerSettingsFromConfig = (base: any, diff: any): any => {
    const baseFramesQueueTriggerSettings =
        base?.vehicle_detection?.['camera-settings']?.modules?.['periodic-images']?.['frames-queue-trigger-settings']
            ?.period_secs

    const diffFramesQueueTriggerSettings =
        diff?.vehicle_detection?.['camera-settings']?.modules?.['periodic-images']?.['frames-queue-trigger-settings']
            ?.period_secs

    // Overwrite base value if diff value exists
    const periodic_images_period_secsFinal =
        diffFramesQueueTriggerSettings !== undefined ? diffFramesQueueTriggerSettings : baseFramesQueueTriggerSettings
    return periodic_images_period_secsFinal / 60
}

export const getDifferences = (submissionCamera: { [key: string]: any }, diffCamera: { [key: string]: any }) => {
    const differences: { [key: string]: any } = {}

    // Loop through each key in submissionCamera
    for (const key in submissionCamera) {
        // If the key also exists in diffCamera
        if (key in diffCamera) {
            // If the values are different, add to differences
            if (Array.isArray(submissionCamera[key])) {
                //case for shutter and gain limits
                if (
                    submissionCamera[key][0] !== diffCamera[key][0] ||
                    submissionCamera[key][1] !== diffCamera[key][1]
                ) {
                    differences[key] = submissionCamera[key]
                }
            } else {
                if (submissionCamera[key] !== diffCamera[key]) {
                    differences[key] = submissionCamera[key]
                }
            }
        } else {
            // If the key doesn't exist in diffCamera, add it to differences
            differences[key] = submissionCamera[key]
        }
    }

    return differences
}

export const buildNewDiffConfig = (diff: any, base: any, submission: any, merged: any) => {
    const finalConfigToSubmit = cloneDeep(diff)
    if (submission.video_recording) {
        finalConfigToSubmit.video_recording = finalConfigToSubmit.video_recording || {}
        finalConfigToSubmit.video_recording.enable = submission?.video_recording?.enable
    }
    finalConfigToSubmit.vehicle_detection = finalConfigToSubmit.vehicle_detection || {}
    finalConfigToSubmit.vehicle_detection['camera-settings'] =
        finalConfigToSubmit.vehicle_detection['camera-settings'] || {}
    finalConfigToSubmit.vehicle_detection['camera-settings'].cameras =
        finalConfigToSubmit.vehicle_detection['camera-settings'].cameras || []

    if (submission?.changed?.camera?.enable_camera && base.vehicle_detection?.['camera-settings']?.cameras.length > 0) {
        // If we found a matching camera, assign the new value
        const mergedCamera = merged.vehicle_detection?.['camera-settings']?.cameras?.[0]
        const diffCamera = diff.vehicle_detection?.['camera-settings']?.cameras?.[0]
        const changedCamera = cloneDeep(submission.changed.camera)
        changedCamera.shutter_limits = [
            submission.changed.camera.shutter_limits_min,
            submission.changed.camera.shutter_limits_max
        ]
        changedCamera.gain_limits = [
            submission.changed.camera.gain_limits_min,
            submission.changed.camera.gain_limits_max
        ]
        delete changedCamera.shutter_limits_min
        delete changedCamera.shutter_limits_max
        delete changedCamera.gain_limits_min
        delete changedCamera.gain_limits_max
        delete changedCamera.label
        delete changedCamera.value
        const matchedCameraItems = getDifferences(changedCamera, mergedCamera)
        const matchedCameraItemsWithDiff = { ...diffCamera, ...matchedCameraItems }
        if (Object.keys(matchedCameraItemsWithDiff).length === 0) {
            //no changes
            delete finalConfigToSubmit.vehicle_detection
        } else {
            finalConfigToSubmit.vehicle_detection['camera-settings'].cameras = [matchedCameraItemsWithDiff]
        }
    }

    const configuration = [
        {
            submissionProp: 'scanner_upload_render',
            baseProp: 'vehicle_detection.scanner.upload_render',
            targetProp: 'vehicle_detection.scanner.upload_render'
        },
        {
            submissionProp: 'enable_video_recording',
            baseProp: 'video_recording.enable',
            targetProp: 'video_recording.enable'
        },
        {
            submissionProp: 'enablePeriodicImages',
            baseProp: 'vehicle_detection.camera-settings.modules.periodic-images.enable',
            targetProp: 'vehicle_detection.camera-settings.modules.periodic-images.enable'
        },
        {
            submissionProp: 'enablePeriodicImages',
            baseProp: 'vehicle_detection.camera-settings.modules.periodic-images.enable',
            targetProp: 'vehicle_detection.camera-settings.modules.periodic-images.enable'
        },
        {
            submissionProp: 'pipeline_mode',
            baseProp: 'vehicle_detection.pipeline_mode',
            targetProp: 'vehicle_detection.pipeline_mode'
        },
        {
            submissionProp: 'snooze_minutes',
            baseProp: 'vehicle_detection.camera-settings.modules.brightness-history-safety-control.snooze_minutes',
            targetProp: 'vehicle_detection.camera-settings.modules.brightness-history-safety-control.snooze_minutes'
        },
        {
            submissionProp: 'reset_history_values',
            baseProp: 'vehicle_detection.camera-settings.modules.brightness-history-value-update.reset_history_values',
            targetProp: 'vehicle_detection.camera-settings.modules.brightness-history-value-update.reset_history_values'
        },
        {
            submissionProp: 'framesQueueTriggerSettings',
            baseProp:
                'vehicle_detection.camera-settings.modules.periodic-images.frames-queue-trigger-settings.period_secs',
            targetProp:
                'vehicle_detection.camera-settings.modules.periodic-images.frames-queue-trigger-settings.period_secs'
        },
        {
            submissionProp: 'enable_raw_image_control',
            baseProp:
                'vehicle_detection.camera-settings.modules.brightness-history-safety-control.enable_raw_image_control',
            targetProp:
                'vehicle_detection.camera-settings.modules.brightness-history-safety-control.enable_raw_image_control'
        }
    ]

    configuration.forEach((config) => {
        let submissionValue = submission.changed[config.submissionProp]
        if (submissionValue !== undefined) {
            const isDifferent = submissionValue !== get(merged, config.baseProp)
            if (isDifferent) {
                if (config.targetProp.includes('frames-queue-trigger-settings.period_secs')) {
                    if (submissionValue * 60 !== get(merged, config.baseProp)) {
                        submissionValue *= 60
                        set(finalConfigToSubmit, config.targetProp, submissionValue)
                    }
                } else {
                    set(finalConfigToSubmit, config.targetProp, submissionValue)
                }
            }
        }
    })

    return finalConfigToSubmit
}
